import React from 'react';

import { selectAppPlugins } from '@vlabs/shared/selectors/appSelectors';
import {
  Table, Panel, Divider,
} from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import st from './PluginsPage.module.sass';
import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';

const PLUGIN_DISPLAY_NAMES = {
  LunaStreams: 'Streams',
};
function StateCell({ value = undefined }) {
  const { t } = useTranslation();
  const stateList = [t('plugins:state.not running'), t('plugins:state.running')];

  return (
    <React.Fragment>
      <div className={cn(st.State, st[value === 0 ? 'State_notRunning' : 'State_running'])} />
      <span>{stateList[value]}</span>
    </React.Fragment>
  );
}

StateCell.propTypes = {
  value: PropTypes.number,
};

function PluginsPageComponents({
  plugins = [],
}) {
  const { t } = useTranslation();
  const pluginsWithDisplayNames = plugins.map((plugin) => ({
    ...plugin,
    displayName: PLUGIN_DISPLAY_NAMES[plugin.name] ?? plugin.name,
  }));

  return (
    <Page>
      <PageContent>
      <PageHeader title={t('plugins:title')} />
      <Panel className="PanelAutoHeight">
        <Table
          columns={[
            {
              Header: t('plugins:table.columns.name'),
              accessor: 'displayName',
            },
            { Header: t('plugins:table.columns.state'), accessor: 'running', Cell: StateCell },
          ]}
          data={pluginsWithDisplayNames}
        />
      </Panel>
      </PageContent>
    </Page>
  );
}

PluginsPageComponents.propTypes = {
  plugins: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    running: PropTypes.number,
  })),
};

export const PluginsPage = connect((state) => ({
  plugins: selectAppPlugins(state),
}))(PluginsPageComponents);
